import SettingReceiveMailPage from "./setting-receive-mail-page" ;

export default SettingReceiveMailPage 